



















































































































































































import { Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { mixins } from 'vue-class-component';

import { required, email } from 'vuelidate/lib/validators';
import { formMixin } from '~/utils/form';

import { countries } from '~/utils/countries.js';

import RadioInput from '~/components/inputs/RadioInput.vue';
import SelectInput from '~/components/inputs/SelectInput.vue';
import TextInput from '~/components/inputs/TextInput.vue';
import EmailInput from '~/components/inputs/EmailInput.vue';
import AreaInput from '~/components/inputs/AreaInput.vue';
import PaperPlaneOutline from '~/components/icons/PaperPlaneOutline.vue';
import ProfileRunEditPhotos from '~/components/partials/ProfileRunEditPhotos.vue';
import PinOutline from '~/components/icons/PinOutline.vue';
import MailOutline from '~/components/icons/MailOutline.vue';
import Toast from '~/components/partials/Toast.vue';
import ErrorCard from '~/components/cards/ErrorCard.vue';

@Component({
  middleware: ['noauth', 'website/contact'],
  components: {
    RadioInput,
    SelectInput,
    TextInput,
    EmailInput,
    AreaInput,
    ProfileRunEditPhotos,
    PaperPlaneOutline,
    PinOutline,
    MailOutline,
    Toast,
    ErrorCard,
  },

  computed: {
    ...mapState('explorer', [
      'destinations',
    ]),
  },

  validations () {
    return {
      userStatus: { required },
      object: { required },
      recipient: { required },
      firstName: { required },
      lastName: { required },
      email: { required, email },
      message: { required },
      selectedCountry: { required },
    };
  },
  head () {
    const self: any = this;
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.$t('website.contact.title')} - On Piste`,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.$t('website.contact.title')} - On Piste`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://www.onpiste.com/img/home/contact_banner.jpeg',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}contact`,
        },
      ],
    };
  },
})
export default class Contact extends mixins(formMixin) {
  destinations: Types.DestinationItem[];

  userStatus: string = '';
  displayToast: boolean = false;
  object: { id: string, name: string } | null = null;
  recipient: any = null;
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  message: string = '';
  selectedCountry: { name: string, id: string, flag?: string} | null = null;

  submittedPictures: Array<string> = [];
  submittedBlobs: Array<File> = [];
  countries: { name: string, id: string, flag?: string}[] = countries;

  /* Returns reactive email objects */
  get objectList () {
    if (this.userStatus === 'PRIVATE') {
      return [
        {
          id: 'PRIVATE_DESTINATION',
          name: this.$t('website.contact.private.destination'),
        },
        {
          id: 'PRIVATE_REQUEST',
          name: this.$t('website.contact.private.request'),
        },
        {
          id: 'PRIVATE_APP',
          name: this.$t('website.contact.private.app'),
        },
        {
          id: 'PRIVATE_CHALLENGE',
          name: this.$t('website.contact.private.challenge'),
        },
        {
          id: 'PRIVATE_ACCOUNT',
          name: this.$t('website.contact.private.account'),
        },
        {
          id: 'PRIVATE_PROBLEM',
          name: this.$t('website.contact.private.problem'),
        },
        {
          id: 'PRIVATE_OTHER',
          name: this.$t('website.contact.private.other'),
        },
      ];
    }

    if (this.userStatus === 'PROFESSIONAL') {
      return [
        {
          id: 'PROFESSIONAL_PROMOTION',
          name: this.$t('website.contact.professional.promotion'),
        },
        {
          id: 'PROFESSIONAL_PARTNER',
          name: this.$t('website.contact.professional.partner'),
        },
        {
          id: 'PROFESSIONAL_CHALLENGE',
          name: this.$t('website.contact.professional.challenge'),
        },
        {
          id: 'PROFESSIONAL_PRESS',
          name: this.$t('website.contact.professional.press'),
        },
        {
          id: 'PROFESSIONAL_OTHER',
          name: this.$t('website.contact.professional.other'),
        },
      ];
    }
    return [];
  }

  /*
    This computed sorts recipients alphabetically, and put onPiste at beginning
    of the array
  */
  get recipientList () {
    const destinations: any = this.destinations.slice(0);
    destinations.sort((a: Types.DestinationItem, b: Types.DestinationItem) => a.title.localeCompare(b.title));
    destinations.unshift({ id: 'onPiste', title: this.$t('website.contact.professional.onpiste') });
    return destinations;
  }

  /*
    When contact form is submitted, we display a toast and remove it
    after 5 seconds
  */
  @Watch('displayToast')
  setToastTimeout () {
    setTimeout(() => {
      this.displayToast = false;
    }, 5000);
  }

  /*
    If user choses PROFESSIONAL status, the recipient will be onPiste,
    so the first one of this.recipientList list
  */
  @Watch('userStatus')
  handleIsPrivate (val: string) {
    if (val === 'PROFESSIONAL') this.recipient = this.recipientList[0];
  }

  mounted () {
    // We render the captcha plugin in the captchaDiv prepared
    const windowObject: any = window;
    windowObject.mtcaptchaConfig.renderQueue.push('captchaDiv');
  }

  beforeDestroy () {
    // Resets URLs created from submitted pictures
    this.submittedPictures.forEach((url: string) => {
      URL.revokeObjectURL(url);
    });
  }

  /*
    This call will prepare submitted pictures to have a valid URL before
    sending the API POST call
  */
  handleUploadedPictures (val: File) {
    this.submittedBlobs.push(val);
    const url = URL.createObjectURL(val);
    this.submittedPictures.push(url);
  }

  /* Remove a submitted picture by index */
  deleteUploadedPicture (val: number) {
    this.submittedPictures.splice(val, 1);
    this.submittedBlobs.splice(val, 1);
  }

  /*
    Before using the API POST method to send the contact form,
    MTCaptcha will check tokens and status submitted. If this one is valid,
    the form will be sent.
 */
  submit () {
    this.formMixin_handleSubmit(async () => {
      const windowObject: any = window;

      const captchaStatus: any = windowObject.mtcaptcha.getStatus();
      const captchaToken: string = windowObject.mtcaptcha.getVerifiedToken();

      if (
        captchaToken !== '' &&
        captchaStatus.isVerified === true &&
        captchaStatus.verifiedToken === captchaToken
      ) {
        await this.$store.dispatch('user/contactOnPiste', {
          destination_id: this.recipient.id === 'onPiste' ? null : this.recipient.id,
          subject_id: this.object?.id,
          message: this.message,
          email: this.email,
          firstname: this.firstName,
          lastname: this.lastName,
          country: this.selectedCountry?.id,
          phone: this.phone,
          attachments: this.submittedBlobs,
        });
        this.displayToast = true;
      } else {
        windowObject.mtcaptcha.showMandatory(); // Validation method
      }
    });
  }
};
